    $('.custom-form_next-step-button').click(function(){
      var current = parseInt($('.custom-form_step').attr('aria-current'));
      var count = parseInt($('.custom-form_step').attr('aria-rowcount'));
      if(current < count){
        var next = current + 1;
        $('.custom-form_step').attr('aria-current',next);
        $('.custom-form_step .current-step').html(next);
        $('.custom-form_step-content[aria-rowindex='+ current +']').hide();
        $('.custom-form_step-content[aria-rowindex='+ next +']').show();
        //$('.custom-form_step-content[aria-rowindex='+ current +']').slideUp(400);
        //$('.custom-form_step-content[aria-rowindex='+ next +']').slideDown(400);
        if(next == count){
          $('.custom-form__next-button').hide();
          $('.custom-form__add-button').show();
          $(this).addClass('disabled');
        }else{
          $(this).removeClass('disabled');
        }
        $('.custom-form_prev-step-button').removeClass('disabled');
      }
    });

    $('.custom-form_prev-step-button').click(function(){
      var current = parseInt($('.custom-form_step').attr('aria-current'));
      var count = parseInt($('.custom-form_step').attr('aria-rowcount'));
      if(current > 1){
        var next = current - 1;
        $('.custom-form_step').attr('aria-current',next);
        $('.custom-form_step .current-step').html(next);
        $('.custom-form_step-content[aria-rowindex='+ current +']').hide();
        $('.custom-form_step-content[aria-rowindex='+ next +']').show();
        //$('.custom-form_step-content[aria-rowindex='+ current +']').slideUp(400);
        //$('.custom-form_step-content[aria-rowindex='+ next +']').slideDown(400);
        if(next == 1){
          $(this).addClass('disabled');
        }else{
          $(this).removeClass('disabled');
        }
        if(next != count){
          $('.custom-form__next-button').show();
          $('.custom-form__add-button').hide();
        }
        $('.custom-form_next-step-button').removeClass('disabled');
      }
    });

    $('.custom-form_close-button').click(function () {
      $('.custom-form__start-container').attr('aria-hidden','false');
      $('.custom-form__add-cart-container').attr('aria-hidden','true');
      //$('.custom-form__sticky-form').attr('aria-expanded','false');
      $('.custom-form__sticky-form').slideUp(400);
    });

    function nextStep(){
      $('.custom-form_next-step-button').click();
    }

  //base64 to Formdata Blob
  function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], {type: mimeString});
  }

  function drawToCanvas(imgData,position){
    var cvs = document.getElementById(position+"_photo_frame");
    var img = new Image;
    img.crossOrigin = 'Anonymous';
    img.id = position+'_upload_file';
    img.src = imgData;
    img.onload = function(){
      cvs.width = img.width;
      cvs.height = img.height;
      var ctx = cvs.getContext('2d');
      ctx.drawImage(img,0,0,cvs.width,cvs.height);
      strDataURI = cvs.toDataURL();
    }
    
    return img;
  }

  function convertCanvasToImage(canvas,position) {
    var image = new Image();
    image.crossOrigin = 'Anonymous';
    image.id = position + '_preview_file';
    image.src = canvas.toDataURL("image/png");
    return image;
  }

  function formatAmount(amount) {
  
    // 将字符串转换为浮点数
    // if(typeof amount === 'string'){
    //   amount = parseFloat(amount);
    // }

    // 除以100
    const result = amount / 100;

    // 保留两位小数
    const formattedResult = result.toFixed(2);
  
    // 创建一个货币格式化器
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify.currency.active,
      currencyDisplay: 'symbol'
    });

    // 格式化金额
    const formattedAmount = formatter.format(formattedResult);

    // 将符号移动到金额前面
    const adjustedAmount = formattedAmount.replace(/^\s*([^\d]*)(.*)$/, '$1$2');

    return adjustedAmount;
  }

  $('.startCustom').click(function(){
    //$('.startCustomModal').show();
    $('.startCustomModal').removeAttr('inert').removeAttr('hidden').attr('open',true).attr('active',true);
  });

  $('.colseCustomModalButton').click(function(){
    //$('.startCustomModal').hide();
    $('.startCustomModal').removeAttr('open').removeAttr('active').attr('inert',true).attr('hidden',true);
  });

  $('#photo_front_file-upload-btn').on('click', function() {
    console.log('front');
    $('#photo_front_file').click();
  });

  $('#photo_back_file-upload-btn').on('click', function() {
    console.log('back');
    $('#photo_back_file').click();
  });

  //选项variant切换后，option提示选中的值
  $('.customOptionSwatche').on('change', function() {
    $('#' + $(this).attr('for')).html($(this).val());
  });

  //生成唯一的uuid,用于产品捆绑判断，在购物车组合显示
  function generateUniqueId() {
    return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
  }

  function updateUpsellPrice(){
    var selected_variants = $('.upsells').find('.upsells__item[attr-checked=true]');
    var selected_product_price = parseFloat(_bubble_price); 
    var selected_variants_array = [];
    selected_variants.each(function(n,v){
      selected_product_price += parseFloat($(this).attr('data-product-price'));
    });

    $('.startCustomModal .price .price__regular').html(formatAmount(selected_product_price));
  }

  $('.drawer__close[aria-controls=CartDrawer]').on('click', function() {
    setTimeout(function() {
      $('body').removeClass('has-modal-opening');
    },300);
  });

  //Fornt photo preview
  const fileInputFront = document.getElementById('photo_front_file');
  const deleteBtnFront = document.getElementById('front-delete-btn');
  if(fileInputFront){
    fileInputFront.addEventListener('change', function(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
          $('#image-preview-front').show();
          $('#image-preview-front .file-name').html(`${file.name}`);
          const size = (file.size / 1024).toFixed(2);
          $('#image-preview-front .file-size').html(`${size} KB`);
        };
        reader.readAsDataURL(file);
      }
    });

    deleteBtnFront.addEventListener('click', function() {
      fileInputFront.value = '';
      $('#image-preview-front').hide();
      $('#image-preview-front .file-name').html('');
      $('#image-preview-front .file-size').html('');

      $("#customFrontCropper").html('');
    });
  }

  //Back photo preview
  const fileInputBack = document.getElementById('photo_back_file');
  const deleteBtnBack = document.getElementById('back-delete-btn');
  if(fileInputBack){
    fileInputBack.addEventListener('change', function(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
          $('#image-preview-back').show();
          $('#image-preview-back .file-name').html(`${file.name}`);
          const size = (file.size / 1024).toFixed(2);
          $('#image-preview-back .file-size').html(`${size} KB`);
        };
        reader.readAsDataURL(file);
      }
    });

    deleteBtnBack.addEventListener('click', function() {
      fileInputBack.value = '';
      $('#image-preview-back').hide();
      $('#image-preview-back .file-name').html('');
      $('#image-preview-back .file-size').html('');

      $("#customFrontCropper").html('');
    });
  }




